import { Injectable, Inject, PLATFORM_ID, Optional, REQUEST } from '@angular/core';
import { isPlatformServer, DOCUMENT } from '@angular/common';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class TenantService {
    private readonly currentDomain: string;

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        @Inject(DOCUMENT) private document: Document,
        // The REQUEST token now provides a standard Web API Request, not an Express request.
        @Optional() @Inject(REQUEST) private request: Request | null
    ) {
        if (isPlatformServer(this.platformId) && this.request) {
            // 1. Server Environment: Extract the hostname using the native URL parser
            const serverUrl = new URL(this.request.url);
            const host = serverUrl.hostname.replace(/^www\./i, '');
            this.currentDomain = (host === 'localhost' || host.includes("efrx")) ? environment.fallbackDomain : host;
        } else {
            // 2. Browser Environment: Read from the Angular document safely
            const host = (this.document.location.hostname || '').replace(/^www\./i, '');
            this.currentDomain = (host === 'localhost' || host.includes("efrx")) ? environment.fallbackDomain : host;
        }
    }

    getDomain(): string {
        return this.currentDomain;
    }
}